export default "__VITE_ASSET__CC5I34lj__"